export const alchemis_lab_data = [
  {
    id: 1,
    image: '/images/labs/blockchain-development-card.png',
    title: 'Blockchain Development',
    text: 'With a focus on cutting-edge technologies and best practices, we provide end-to-end support, from strategic planning and development to auditing and maintenance.',
    url: '/labs/blockchain-development',
  },
  {
    id: 2,
    image: '/images/labs/smart-development-card.png',
    title: 'Smart Contracts Development',
    text: 'Our team of skilled developers creates and deploys secure, audited, and efficient smart contracts for various use cases, including tokenization, decentralized finance (DeFi), and NFT marketplaces.',
    url: '/labs/smart-contract-development',
  },
  {
    id: 3,
    image: '/images/labs/dApp-card.png',
    title: 'Decentralized Application (dApps) Development',
    text: 'We build highly secure, scalable, and efficient dApps on various blockchain platforms like Ethereum, Optimism, Arbitrum, and Binance Smart Chain, ensuring seamless integration with your existing systems.',
    url: '/labs/dapp-development',
  },
  {
    id: 4,
    image: '/images/labs/blockchain-consultation-card.png',
    title: 'Blockchain Consultation',
    text: 'We offer comprehensive blockchain consultation services to help you identify the best use cases and strategies for implementing blockchain technology in your organization.',
    url: '/labs/blockchain-consulting',
  },
  {
    id: 5,
    image: '/images/labs/tokenization-card.png',
    title: 'Tokenization Services',
    text: 'We help you develop custom tokens, manage token sales, and design tokenomics that align with your project\'s goals and vision.',
    url: '/labs/tokenization-services',
  },
  {
    id: 6,
    image: '/images/labs/non-fungible-card.png',
    title: 'Non-Fungible Tokens (NFT) Solutions',
    text: 'We create unique and innovative NFT platforms, marketplaces, and digital asset management systems that unlock new revenue streams for businesses in various industries.',
    url: '/labs/non-fungible-tokens',
  },
]
